import _ from 'lodash'

//This function takes care of comparison of actual values for sorting purposes
//handle cases such as N/A and nulls
export default function compareActualValues (a, b, opts) {
	if (_.isNil(a)) {
		if (_.isNil(b)) {
			return 0
		}
		return 1
	} else if (_.isNil(b)) {
		return -1
	}

	//if both number compare numerically
	if (_.isFinite(a.actual) && _.isFinite(b.actual)) {
		if (opts.reversed) {
			return b.actual-a.actual
		}
		return a.actual-b.actual
	}
	//if a is a number it's always before a N/A or null
	if (_.isFinite(a.actual)) {
		if (!b.applicable || _.isEmpty(b.actual)) {
			return -1
		}
	}
	//likewise with b
	if (_.isFinite(b.actual)) {
		if (!a.applicable || _.isEmpty(a.actual)) {
			return 1
		}
	}
	//if a and b are both N/A they are equal
	if (!a.applicable && !b.applicable) {
		return 0
	}
	//if only A is N/A it comes before nulls
	if (!a.applicable) {
		return -1
	}
	//same with b
	if (!b.applicable) {
		return 1
	}
	//a and b must be nulls/empty they are equal
	return 0
}
